import { injectable } from 'tsyringe'
import { DashboardApiRepository } from '@/app/repositories/api/DashboardApiRepository'
import { Dashboard } from '@/domain/entities/Dashboard'

@injectable()
export class DashboardPresenter {
  private repository: DashboardApiRepository

  constructor(repository: DashboardApiRepository) {
    this.repository = repository
  }

  public loadDashboard(params: Object): Promise<Dashboard> {
    return this.repository.getAll(params)
  }
}
